import React, {type ReactNode} from 'react';

import cs from 'classnames';
import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

const StyledFilterbarDIV = styled.div.attrs(
  (props: React.HTMLAttributes<HTMLDivElement>) => ({
    className: cs('card', props.className),
  })
)`
  background-color: ${colors.lightGray};
  border-color: rgba(0, 0, 0, 0.05);
  border-radius: 0;
  border-top: 0;
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode; // Extend div props, so no need to manually define `className`
}

export const TeamPageFilterBarStructure = ({children, className}: Props) => (
  <StyledFilterbarDIV className={className}>
    <div className="card-body p-2">
      <div className="row no-gutters align-items-center">{children}</div>
    </div>
  </StyledFilterbarDIV>
);
